
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0C4.037 0 0 4.046 0 9.019c0 2.797 1.444 6.045 4.293 9.655 2.084 2.641 4.138 4.466 4.224 4.543a.73.73 0 00.966 0c.086-.077 2.14-1.902 4.224-4.543C16.556 15.064 18 11.816 18 9.019 18 4.046 13.963 0 9 0zm0 21.671C7.266 20.015 1.46 14.09 1.46 9.02c0-4.167 3.382-7.556 7.54-7.556 4.158 0 7.54 3.39 7.54 7.556 0 5.071-5.806 10.996-7.54 12.652z","fill":"#BBAD9C"}}),_c('path',{attrs:{"d":"M14.583 8.585L9.475 4.198a.727.727 0 00-.95 0L3.417 8.585a.733.733 0 00-.08 1.032.728.728 0 001.03.079l.62-.532v3.633a.73.73 0 00.729.731h6.568a.73.73 0 00.73-.731V9.163l.619.532a.731.731 0 00.95-1.11zm-3.03 3.48H6.447V7.91L9 5.716l2.554 2.194v4.156z","fill":"#BBAD9C"}})])
          )
        }
      }
    